import { format } from "date-fns";
import * as React from "react";
import "../../style/HQDashboard.css";

const PieChartTooltip = (props: any) => {
  const color = props.datum.color;
  return (
    <div style={{ height: "60px", width: "110px", backgroundColor: "#ffffff", position: "relative" }}>
      <div style={{ textAlign: "center", height: "18px" }}>
        <h6
          id="truncate-tooltip"
          style={{
            fontSize: 11,
            color: "#8B95A0",
            padding: "5px",
          }}
        >
          {props.datum.id}
        </h6>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "baseline",
        }}
      >
        <div
          style={{
            height: "7px",
            width: "7px",
            backgroundColor: color,
            borderRadius: "50%",
          }}
        ></div>
        <div>
          <h6 style={{ fontSize: 11, color: "#14191C" }}>{props.datum.value ? props.datum.value : 0}</h6>
        </div>
      </div>
      <div style={{ position: "absolute", height: "23px", width: "23px", backgroundColor: "#ffffff", top: 45, left: 40, transform: `rotate(45deg)`, zIndex: -1 }}></div>
    </div>
  );
};

export default PieChartTooltip;
